webpackJsonp([1],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(243)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  "data-v-5d7e1e86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ["url"],
    methods: {
        openArticle: function openArticle() {
            this.$router.push(this.url);
        }
    }
};

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".readmore[data-v-5d7e1e86]{max-width:30rem;text-align:center;padding:.5rem;border:1px solid #ddd;background:hsla(0,0%,100%,.11);color:#1f6dc6;display:block;border-radius:5px;margin:1.5rem auto;font-size:1.1rem;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;box-shadow:0 3px 10px 2px rgba(0,0,0,.1)}.readmore__external[data-v-5d7e1e86]{position:absolute;right:0;padding:0 10px;height:100%;top:0;display:flex;align-items:center;border-left:1px solid #577f40}.readmore__external a[data-v-5d7e1e86]{color:#577f40}", ""]);

// exports


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "readmore",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openArticle($event)
      }
    }
  }, [_c('span', {
    staticClass: "readmore__external"
  }, [_c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "readmore__tag"
  }, [_vm._v("Read more: ")]), _vm._v(" "), _c('span', {
    staticClass: "readmore__link"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(232);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("115fdb5b", content, true);

/***/ })

});


// WEBPACK FOOTER //
// 1.min.js